// Единственный источник значений сортировки ленты. Живёт отдельно от
// `types.ts` (а не как `export const` там) — dependency-cruiser требует
// type-only импортов из файлов `types.ts` (см. dependency-cruiser.cjs,
// правило `only-type-only-from-types`), а FEED_SORTS нужен как runtime-массив
// (zod-схема сортировки в routes/_authenticated/feed/index.tsx).
export const FEED_SORTS = ["chrono", "stars"] as const
export type FeedSort = (typeof FEED_SORTS)[number]
